import { computed, Directive } from '@angular/core';
import { ProductComponentBase } from '../ProductComponentBase';

@Directive()
export abstract class CommonProductDetailsComponentBase extends ProductComponentBase {
  protected readonly productDetails = this.productStore.productDetails;

  protected override computeIsLoading = () => this.productDetails.loading;
  protected override computeHasContent = () => computed(() => !!this.productDetails.error() || !!this.productDetails());
}
